<template>
	<svg t="1686291801896" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2154"
		xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
		<path
			d="M95.589 130.079h236.5v767.6h-236.5zM437.089 503.179h488.5v394.5h-488.5zM437.089 130.079h488.5v266.5h-488.5z"
			p-id="2155"></path>
	</svg>
</template>
